import { Injectable } from '@angular/core';
import { FilterModel } from 'src/app/shared/models/common-model';
import { CommonService } from 'src/app/shared/services/common.service';
@Injectable({
  providedIn: 'root'
})
export class DBQPatientService {
  getAllURL = 'DBQDoctor/all-patients';
  getByIdURL = "DBQDoctor/patient-by-id";
  getWithoutAuthByIdURL = "DBQDoctor/appointment-patient-by-id";
  createURL = "DBQDoctor/create-patient";
  updateURL = "DBQDoctor/patient-update";
  updateWithoutAuthURL = "DBQDoctor/appointment-patient-update";
  deleteURL = "DBQDoctor/patient-delete";

  getAllPatientInvitesURL = 'DBQDoctor/all-patient-invites';
  getPatientInviteByIdURL = "DBQDoctor/patient-invite-by-id";
  createPatientInviteURL = "DBQDoctor/create-patient-invite";
  createPatientFollowupInviteURL = "DBQDoctor/create-patient-followup-invite";

  constructor(private commonService: CommonService) { }

  getById(id: number) {
    return this.commonService.getById(this.getByIdURL + "?Id=" + id, {});
  }

  getWithoutAuthById(id: number) {
    return this.commonService.getWithoutAuthById(this.getWithoutAuthByIdURL + "?Id=" + id, {});
  }

  getPatientInviteById(id: number) {
    return this.commonService.getById(this.getPatientInviteByIdURL + "?Id=" + id, {});
  }
  save(userModel: any) {
    return this.commonService.post(this.createURL, userModel);
  }
  savePatientInvite(userModel: any) {
    return this.commonService.post(this.createPatientInviteURL, userModel);
  }

  savePatientFollowupInvite(userModel: any) {
    return this.commonService.post(this.createPatientFollowupInviteURL, userModel);
  }
  update(userModel: any) {
    return this.commonService.put(this.updateURL, userModel);
  }
  updateWithoutAuth(userModel: any) {
    return this.commonService.put(this.updateWithoutAuthURL, userModel);
  }
  delete(id: number) {
    return this.commonService.delete(`${this.deleteURL}?id=${id}`, {})
  }

  getAll(filterModal: FilterModel) {
    return this.commonService.getAll(this.getAllURL, filterModal.currentPage, filterModal.pageSize,
      filterModal.searchText, filterModal.sortOrder, filterModal.orderBy, filterModal.status, filterModal.statusType);
  }

  getAllPatientInvite(filterModal: FilterModel) {
    return this.commonService.getAll(this.getAllPatientInvitesURL, filterModal.currentPage, filterModal.pageSize,
      filterModal.searchText, filterModal.sortOrder, filterModal.orderBy, filterModal.status, filterModal.statusType, filterModal.hospitalId, filterModal.statusIds, filterModal.doctorIds, filterModal.dateFrom, filterModal.dateTo, filterModal.isActiveShift, filterModal.hospitalUserId, filterModal.dbqPatientId);
  }

}
